var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegenerateOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1353_73475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5C36.9787 0.5 47.5 11.0213 47.5 24Z",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.736 18.972V23.988C17.736 25.508 18.12 26.924 18.888 28.236C19.624 29.5 20.624 30.5 21.888 31.236C23.2 32.004 24.608 32.388 26.112 32.388C27.632 32.388 29.048 32.004 30.36 31.236C31.624 30.5 32.624 29.5 33.36 28.236C34.128 26.924 34.512 25.516 34.512 24.012C34.512 22.492 34.128 21.076 33.36 19.764C32.624 18.5 31.624 17.5 30.36 16.764C29.048 15.996 27.632 15.612 26.112 15.612V14.124C27.904 14.124 29.568 14.572 31.104 15.468C32.592 16.348 33.776 17.532 34.656 19.02C35.552 20.54 36 22.196 36 23.988C36 25.78 35.552 27.444 34.656 28.98C33.776 30.468 32.592 31.652 31.104 32.532C29.568 33.428 27.904 33.876 26.112 33.876C24.32 33.876 22.664 33.428 21.144 32.532C19.656 31.652 18.472 30.468 17.592 28.98C16.696 27.444 16.248 25.78 16.248 23.988V18.972L13.272 21.948C13.128 22.092 12.952 22.164 12.744 22.164C12.536 22.164 12.36 22.092 12.216 21.948C12.072 21.788 12 21.612 12 21.42C12 21.212 12.072 21.036 12.216 20.892L16.992 16.116L21.768 20.892C21.912 21.036 21.984 21.212 21.984 21.42C21.984 21.612 21.912 21.788 21.768 21.948C21.624 22.092 21.448 22.164 21.24 22.164C21.048 22.164 20.864 22.092 20.688 21.948L17.736 18.972Z",
    fill: "#A3A3A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1353_73475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegenerateOutline);
export default __webpack_public_path__ + "static/media/regenerate-outline.7fe94f875c8ad18d82d6db199d2b8e4c.svg";
export { ForwardRef as ReactComponent };